import { createClient } from "@supabase/supabase-js";

// Vite exposes env via import.meta.env only in the browser
const supabaseUrl: string | undefined = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey: string | undefined = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.warn(
    "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Set them in apps/web/.env.local"
  );
}

export const supabase = createClient(supabaseUrl ?? "", supabaseAnonKey ?? "");

if (import.meta.env.DEV && typeof window !== "undefined") {
  const metricsKey = "__realtimeMetrics";
  const existing = (window as any)[metricsKey] as
    | { total: number; byType: Record<string, number> }
    | undefined;

  if (!existing) {
    const metrics = {
      total: 0,
      byType: {} as Record<string, number>,
    };
    (window as any)[metricsKey] = metrics;

    const realtimeWithDebug = supabase.realtime as typeof supabase.realtime & {
      onDebug?: (callback: (message: any) => void) => void;
    };

    realtimeWithDebug.onDebug?.((message) => {
      metrics.total += 1;
      const type = typeof message === "string" ? "debug" : message?.type || "event";
      metrics.byType[type] = (metrics.byType[type] || 0) + 1;
    });

    setInterval(() => {
      const { total, byType } = metrics;
      // Log minimal et regroupé pour éviter le spam console
      // eslint-disable-next-line no-console
      console.info("[Realtime Metrics]", { total, byType });
    }, 10000);
  }
}

